import { RPInstance } from './base';

const authNJApi = {};
const baseUrl = 'jp/v1';

// OTP 등록여부 확인
authNJApi.checkOTP = () => {
  return RPInstance.get(`${baseUrl}/otp`);
};

// 본인확인 정보 조회
authNJApi.getAuthData = () => {
  return RPInstance.get(`${baseUrl}/identification`);
};

// 본인확인 정보 등록
authNJApi.setAuthData = (val) => {
  return RPInstance.post(`${baseUrl}/identification`, val);
};

// 본인확인 정보 수정
authNJApi.editAuthData = (val) => {
  return RPInstance.put(`${baseUrl}/identification`, val);
};

// 등록된 파일 리스트 조회
authNJApi.getFileList = () => {
  return RPInstance.get(`${baseUrl}/identification/upload`);
};

// 파일 업로드
authNJApi.uploadFiles = (val) => {
  return RPInstance.post(`${baseUrl}/identification/upload`, val, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};

export default {
  ...authNJApi,
};
